<template>
  <div>
    <div class="upload-wrapper">
      <Tinymce :accept="accept" :form="form" :model="models"></Tinymce>
    </div>
    <!-- <div>
      <el-input
        v-model="inputData"
        placeholder="Please input"
        style="width: 400px; max-width: 100%"
      />
      <el-button
        type="primary"
        icon="el-icon-document"
        @click="handleCopy(inputData, $event)"
      >
        copy
      </el-button>
    </div> -->
  </div>
</template>

<script>
import UploadPan from '@/components/Upload/index'
import Tinymce from '@/components/Tinymce/index'
import clip from '/util/clipboard.js' // use clipboard directly
export default {
  name: 'App',
  components: {
    UploadPan,
    Tinymce,
  },
  data() {
    return {
      inputData: '',
      fileList: [],
      models: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF',
    }
  },
  methods: {
    handleCloseUpload() {
      this.fileList = []
    },
    handleOnUpdate(obj) {
      console.log('handleOnUpdate')
      console.log(obj)
    },
    handleCopy(text, event) {
      clip(text, event)
    },
  },
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
.btn-wrapper {
  margin: 20px 0;
}
.form-wrapper {
  width: 500px;
  margin: 25px auto;
  .alert {
    margin-bottom: 10px;
  }
}
</style>
